import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { ReactComponent as HourGlassIcon } from '../../assets/images/hour-glass-icon.svg';
import { BLACK, PRIMARY } from '../../utils/colors';

const TimerContainer = styled.div`
  background: #FFF8F0;
  border-radius: 0px 0px 12px 12px;
  padding: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: -12px;
  margin-bottom: 24px;
  
  @media (min-width: 992px) {
    margin-top: -40px;
  }
`;

const TextContent = styled.div`
  flex: 1;
  padding-right: 24px;
`;

const TimerText = styled.p`
  font-size: 14px;
  color: ${BLACK};
  margin: 0 0 16px 0;
  line-height: 1.5;
`;

const Pill = styled.div`
  background: #FF6B4E;
  color: white;
  padding: 4px 12px;
  border-radius: 100px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
  font-size: 14px;
`;

const GraphicContainer = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  border: 2px dashed ${PRIMARY};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const PaymentTimerCard = () => {
  const [timeLeft, setTimeLeft] = useState(59);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const formatTime = (seconds: number) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s < 10 ? '0' : ''}${s}`;
  };

  return (
    <TimerContainer>
      <TextContent>
        <TimerText>
          Complete your payment before the timer runs out to secure your seat and fare.
        </TimerText>
        <Pill>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.06703 1.59828C6.16648 1.85589 6.03826 2.14535 5.78064 2.24479C5.68635 2.28119 5.59318 2.31984 5.50118 2.36068C5.24879 2.47273 4.95336 2.35896 4.84131 2.10657C4.72927 1.85418 4.84304 1.55875 5.09543 1.4467C5.20243 1.3992 5.31082 1.35423 5.42052 1.31189C5.67814 1.21244 5.96759 1.34066 6.06703 1.59828ZM3.76579 2.82676C3.95623 3.02673 3.94851 3.34322 3.74854 3.53366C3.67543 3.60329 3.60402 3.67469 3.53439 3.74781C3.34395 3.94777 3.02746 3.9555 2.82749 3.76505C2.62753 3.57461 2.61981 3.25812 2.81025 3.05816C2.89109 2.97327 2.974 2.89036 3.05889 2.80951C3.25886 2.61907 3.57534 2.6268 3.76579 2.82676ZM2.1073 4.84058C2.35969 4.95263 2.47346 5.24806 2.36141 5.50045C2.32057 5.59245 2.28192 5.68562 2.24552 5.77991C2.14608 6.03753 1.85663 6.16575 1.59901 6.0663C1.3414 5.96686 1.21317 5.6774 1.31262 5.41979C1.35496 5.31009 1.39993 5.2017 1.44743 5.0947C1.55948 4.84231 1.85491 4.72854 2.1073 4.84058ZM1.34804 7.33595C1.6241 7.34262 1.84249 7.57182 1.83582 7.84788C1.8346 7.8984 1.83398 7.94908 1.83398 7.99992C1.83398 8.05075 1.8346 8.10143 1.83582 8.15196C1.84249 8.42802 1.6241 8.65722 1.34804 8.66389C1.07198 8.67056 0.84278 8.45217 0.836111 8.17611C0.834696 8.11754 0.833984 8.05881 0.833984 7.99992C0.833984 7.94103 0.834696 7.8823 0.836111 7.82373C0.84278 7.54767 1.07198 7.32928 1.34804 7.33595ZM14.4023 9.93353C14.6599 10.033 14.7881 10.3224 14.6887 10.58C14.6463 10.6897 14.6014 10.7981 14.5539 10.9051C14.4418 11.1575 14.1464 11.2713 13.894 11.1593C13.6416 11.0472 13.5278 10.7518 13.6399 10.4994C13.6807 10.4074 13.7194 10.3142 13.7558 10.2199C13.8552 9.96231 14.1447 9.83409 14.4023 9.93353ZM1.59901 9.93353C1.85663 9.83409 2.14608 9.96231 2.24552 10.2199C2.28192 10.3142 2.32057 10.4074 2.36141 10.4994C2.47346 10.7518 2.35969 11.0472 2.1073 11.1593C1.85491 11.2713 1.55948 11.1575 1.44743 10.9051C1.39993 10.7981 1.35496 10.6897 1.31262 10.58C1.21317 10.3224 1.3414 10.033 1.59901 9.93353ZM13.1738 12.2348C13.3738 12.4252 13.3815 12.7417 13.1911 12.9417C13.1102 13.0266 13.0273 13.1095 12.9424 13.1903C12.7424 13.3808 12.426 13.373 12.2355 13.1731C12.0451 12.9731 12.0528 12.6566 12.2528 12.4662C12.3259 12.3965 12.3973 12.3251 12.4669 12.252C12.6574 12.0521 12.9738 12.0443 13.1738 12.2348ZM2.82749 12.2348C3.02746 12.0443 3.34395 12.0521 3.53439 12.252C3.60402 12.3251 3.67543 12.3965 3.74854 12.4662C3.94851 12.6566 3.95623 12.9731 3.76579 13.1731C3.57535 13.373 3.25886 13.3808 3.05889 13.1903C2.974 13.1095 2.89109 13.0266 2.81025 12.9417C2.61981 12.7417 2.62753 12.4252 2.82749 12.2348ZM4.84132 13.8933C4.95336 13.6409 5.24879 13.5271 5.50118 13.6392C5.59318 13.68 5.68635 13.7186 5.78064 13.755C6.03826 13.8545 6.16648 14.1439 6.06704 14.4016C5.96759 14.6592 5.67814 14.7874 5.42052 14.688C5.31082 14.6456 5.20243 14.6006 5.09543 14.5531C4.84304 14.4411 4.72927 14.1457 4.84132 13.8933ZM11.16 13.8933C11.272 14.1457 11.1583 14.4411 10.9059 14.5531C10.7989 14.6006 10.6905 14.6456 10.5808 14.6879C10.3232 14.7874 10.0337 14.6592 9.93427 14.4016C9.83482 14.1439 9.96304 13.8545 10.2207 13.755C10.3149 13.7186 10.4081 13.68 10.5001 13.6392C10.7525 13.5271 11.0479 13.6409 11.16 13.8933ZM7.33668 14.6525C7.34335 14.3765 7.57255 14.1581 7.84861 14.1648C7.89913 14.166 7.94982 14.1666 8.00065 14.1666C8.05149 14.1666 8.10217 14.166 8.15269 14.1648C8.42875 14.1581 8.65795 14.3765 8.66462 14.6525C8.67129 14.9286 8.4529 15.1578 8.17684 15.1645C8.11827 15.1659 8.05954 15.1666 8.00065 15.1666C7.94176 15.1666 7.88303 15.1659 7.82446 15.1645C7.5484 15.1578 7.33001 14.9286 7.33668 14.6525Z" fill="white" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.50065 1.33325C7.50065 1.05711 7.72451 0.833252 8.00065 0.833252C11.9587 0.833252 15.1673 4.04188 15.1673 7.99992C15.1673 8.27606 14.9435 8.49992 14.6673 8.49992C14.3912 8.49992 14.1673 8.27606 14.1673 7.99992C14.1673 4.59416 11.4064 1.83325 8.00065 1.83325C7.72451 1.83325 7.50065 1.60939 7.50065 1.33325ZM8.00065 5.49992C8.27679 5.49992 8.50065 5.72378 8.50065 5.99992V8.16658H10.6673C10.9435 8.16658 11.1673 8.39044 11.1673 8.66658C11.1673 8.94273 10.9435 9.16658 10.6673 9.16658H8.00065C7.72451 9.16658 7.50065 8.94273 7.50065 8.66658V5.99992C7.50065 5.72378 7.72451 5.49992 8.00065 5.49992Z" fill="white" />
          </svg>
          {formatTime(timeLeft)}
        </Pill>
      </TextContent>

      <HourGlassIcon width={92} height={92} />

    </TimerContainer>
  );
};

export default PaymentTimerCard;
